import { InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class GetPublicProductSpecificationsArgs extends ActionArgs {}

export interface IGetPublicProductSpecifications extends IAction<string, GetPublicProductSpecificationsArgs> {}
